import React, { useState } from "react";
import { Box, Modal, Paper, Typography, alpha } from "@mui/material";
import { useThemeContext } from "../../../../core/contexts/ThemeContext";
import { cores, raio, superficieModo, texto } from "../identidade";

interface ImagemBubbleProps {
    imagemUrl: string;
    caption?: string;
    timestamp: string;
    position: "left" | "right";
    color?: string;
}

const ImagemBubble: React.FC<ImagemBubbleProps> = ({ imagemUrl, caption, timestamp, position, color }) => {
    const isRight = position === "right";
    const { theme, themeName } = useThemeContext();
    const [modalAberto, setModalAberto] = useState(false);

    // Mesmo par de tons das bolhas de texto: tint da marca na loja, overlay
    // neutro no cliente.
    const bgColor = color || (isRight
        ? alpha(cores.marca[500], themeName === "dark" ? 0.22 : 0.14)
        : superficieModo(themeName, themeName === "dark" ? 0.07 : 0.05));

    const corBorda = isRight
        ? alpha(cores.marca[500], themeName === "dark" ? 0.42 : 0.24)
        : superficieModo(themeName, 0.09);

    return (
        <>
            <Box
                display="flex"
                justifyContent={isRight ? "flex-end" : "flex-start"}
            >
                <Paper
                    elevation={0}
                    sx={{
                        p: 1,
                        maxWidth: "82%",
                        backgroundColor: bgColor,
                        border: `1px solid ${corBorda}`,
                        backgroundImage: "none",
                        position: "relative",
                    borderRadius: raio.bolha,
                        cursor: "pointer",
                    }}
                    onClick={() => setModalAberto(true)}
                >
                    <Box
                        component="img"
                        src={imagemUrl}
                        alt={caption || "Imagem"}
                        sx={{
                            display: "block",
                            maxWidth: "100%",
                            maxHeight: 300,
                            borderRadius: 0,
                            objectFit: "cover",
                        }}
                    />
                    {caption && (
                        <Typography
                            variant="body2"
                            sx={{ mt: 0.5, px: 0.5, wordBreak: "break-word" }}
                        >
                            {caption}
                        </Typography>
                    )}
                    <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            textAlign: "right",
                            mt: 0.5,
                            opacity: 0.6,
                            ...texto.apoio,
                        }}
                    >
                        {timestamp}
                    </Typography>
                </Paper>
            </Box>

            <Modal open={modalAberto} onClose={() => setModalAberto(false)}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    height="100vh"
                    onClick={() => setModalAberto(false)}
                    sx={{ cursor: "zoom-out" }}
                >
                    <Box
                        component="img"
                        src={imagemUrl}
                        alt={caption || "Imagem"}
                        sx={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            objectFit: "contain",
                            borderRadius: 2,
                            boxShadow: 24,
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </Box>
            </Modal>
        </>
    );
};

export default ImagemBubble;
